export interface UnitOperationsState {
  unitId: number;
  status: 'loading' | 'inactive' | 'ready' | 'started' | 'blocked' | 'unavailable';
  startDate: string | null;
  errors: string[];
}

export const OPERATION_ERRORS: Record<string, string> = {
  SETTLEMENT_ERROR: 'Falta configuración de condominio',
  SETTLEMENT_ADDRESS_ERROR: 'Falta dirección de condominio',
  TENANT_ERROR: 'Falta usuario',
  GAS_METER_ERROR: 'Falta medidor',
  TANK_ERROR: 'Falta tanque',
  TENANT_FISCAL_ERROR: 'Faltan datos fiscales',
  BUILDING_ERROR: 'Falta edificio',
  FLOOR_ERROR: 'Falta piso',
  GAS_METER_ON_GRACE_PERIOD: 'Medidor sin requisitos cumplidos en tiempo de gracia',
  TANK_ON_GRACE_PERIOD: 'Tanque sin requisitos cumplidos en tiempo de gracia'
};
